import Head from 'next/head';
import type { NextPage } from 'next';
import { useRouter } from 'next/router';
import { env } from '@zopauk/nextjs-env';
import { Modules } from '@/components/Modules';
import { renderMetaTags } from 'react-datocms';
import { withSession } from '@zopauk/nextjs-auth';
import { PreviewToast } from '@/components/preview/Toast';
import { useCategoryQuery } from '@/utils/dato/generated';
import { type CategoryModules, type CategoryContext, getServerSideProps } from '@/utils/models/category';

const Category: NextPage<CategoryContext> = (context) => {
  const { query } = useRouter();
  const { data } = useCategoryQuery({
    perPage: context.pagination.perPage,
    skip: context.pagination.skip,
    slug: context.slug,
  });

  const page = Array.isArray(query.page) ? query.page[0] : query.page;

  const isPaginated = page && page !== '1';

  const canonical = `${env('NEXT_PUBLIC_WEB_GALLERIA_URL')}/blog/category/${context.slug}${isPaginated ? `?page=${page}` : ''}`;

  const baseTitle = data?.category?.seo?.find((tag) => tag.tag === 'title')?.content || 'Zopa Blog';

  const paginatedTitle = isPaginated ? `${baseTitle} - Page ${page}` : baseTitle;

  return (
    <>
      <Head>
        {data?.category?.seo ? renderMetaTags(data.category.seo.concat(data.site.favicon)) : null}
        <title>{paginatedTitle}</title>
        <link href={canonical} rel="canonical" />
      </Head>
      {data?.template?.modular ? (
        <Modules<CategoryModules, CategoryContext> modules={data.template.modular} context={context} />
      ) : null}
      <PreviewToast />
    </>
  );
};

export { getServerSideProps };

export default withSession(Category, { forceLogin: false });
